/* IndexedDB tabanlı offline giriş kuyruğu.
 * Kayıt formatı: { id (auto), kind: "material"|"bulk", payload, photoBlob?, createdAt, tries }
 * Kullanım:
 *   const q = openQueue();
 *   await q.enqueue({ kind:"material", payload, photoFile? })
 *   await q.getAll(); await q.remove(id); await q.count();
 *   subscribe(cb) → count değiştikçe tetiklenir.
 */

const DB_NAME = "mss-offline";
const DB_VER = 1;
const STORE = "pending";

const listeners = new Set();
const notify = (n) => listeners.forEach((cb) => cb(n));

const openDB = () =>
  new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VER);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });

const withStore = async (mode, fn) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const store = tx.objectStore(STORE);
    let result;
    tx.oncomplete = () => resolve(result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
    Promise.resolve(fn(store)).then((r) => (result = r));
  });
};

export const enqueueMaterial = async ({ kind, payload, photoFile }) => {
  const rec = {
    kind,
    payload,
    photoBlob: photoFile || null,
    photoName: photoFile?.name || null,
    photoType: photoFile?.type || null,
    createdAt: new Date().toISOString(),
    tries: 0,
    lastError: null,
  };
  await withStore("readwrite", (store) => new Promise((res) => {
    const r = store.add(rec);
    r.onsuccess = () => res(r.result);
  }));
  const n = await countPending();
  notify(n);
  return n;
};

export const getAllPending = () =>
  withStore("readonly", (store) => new Promise((res) => {
    const r = store.getAll();
    r.onsuccess = () => res(r.result || []);
  }));

export const countPending = () =>
  withStore("readonly", (store) => new Promise((res) => {
    const r = store.count();
    r.onsuccess = () => res(r.result || 0);
  }));

export const removePending = async (id) => {
  await withStore("readwrite", (store) => new Promise((res) => {
    const r = store.delete(id);
    r.onsuccess = () => res();
  }));
  notify(await countPending());
};

export const updatePending = async (id, patch) => {
  await withStore("readwrite", (store) => new Promise((res) => {
    const g = store.get(id);
    g.onsuccess = () => {
      const cur = g.result;
      if (!cur) return res();
      const upd = { ...cur, ...patch };
      const p = store.put(upd);
      p.onsuccess = () => res();
    };
  }));
};

export const subscribeQueue = (cb) => {
  listeners.add(cb);
  // ilk değeri hemen ver
  countPending().then(cb).catch(() => {});
  return () => listeners.delete(cb);
};

export const notifyCount = async () => notify(await countPending());
